function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t\t.st0 {\r\n\t\t\tfill: none;\r\n\t\t\tstroke: #000000;\r\n\t\t\tstroke-width: 2;\r\n\t\t}\r\n\r\n\t\t.st1 {\r\n\t\t\tfill: none;\r\n\t\t\tstroke: #000000;\r\n\t\t\tstroke-width: 2;\r\n\t\t}\r\n\t");

var _ref3 = /*#__PURE__*/React.createElement("polyline", {
  className: "st0",
  points: "3,10 16,18 29,10 "
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M7,12.5V3c0-1.1,0.9-2,2-2h14c1.1,0,2,0.9,2,2v9.5"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M25,5c2.2,0,4,1.8,4,4v14c0,2.2-1.8,4-4,4H7c-2.2,0-4-1.8-4-4V9c0-2.2,1.8-4,4-4"
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 11,
  y1: 5,
  x2: 18,
  y2: 5
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 11,
  y1: 9,
  x2: 14,
  y2: 9
});

function SvgEmailTemplate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailTemplate);
export default __webpack_public_path__ + "static/media/EmailTemplate.ba560bdd.svg";
export { ForwardRef as ReactComponent };